import { getV2, postV2, patchV2, deletedV2 } from 'api/request'

export const API_LEAD = "/core/lead/lead"

// v2 registers the bare collection path WITH a trailing slash ("/core/lead/lead/") but
// detail/"groups"/action paths WITHOUT one — confirmed against the live schema, not
// derivable from whether the call takes query params (groups takes filters and still
// has no trailing slash).
export const getLeadList = (schemeKey, offset = 0, size = 20, filters = {}) => {
  const params = { scheme: schemeKey, offset, size, ...filters }
  return getV2(`${API_LEAD}/`, { urlParams: params })
}

export const getLeadGroups = (schemeKey, filters = {}) => (
  getV2(`${API_LEAD}/groups`, { urlParams: { scheme: schemeKey, ...filters } })
)

export const getLeadDetail = (leadKey) => getV2(`${API_LEAD}/${leadKey}`)

export const createLead = (data) => postV2(`${API_LEAD}/`, data)

export const updateLead = (leadKey, data) => patchV2(`${API_LEAD}/${leadKey}`, data)

// DELETE /v2/core/lead/lead/{uid} -> 204 No Content (live schema, 2026-10-09); the uid is a plain path
// param — no body, no query.
export const deleteLead = (leadKey) => deletedV2(`${API_LEAD}/${leadKey}`)

export const closeLead = (leadKey) => postV2(`${API_LEAD}/${leadKey}/close`, {})

export const reopenLead = (leadKey) => postV2(`${API_LEAD}/${leadKey}/reopen`, {})

// Lead follow-up (live schema, 2026-10-14). A follow-up is a reason plus a list of sequences (attempts), read back
// from the lead's `followup_data` ({ reason, completed_at, sequences: [{ followup_time, completed_at, completed_by }] })
// and `followup_since`. `next_followup_time` is no longer reliable, and `next_followup_reason` / `waiting_since` are gone.
// PATCH lead/{uid}/followup sets or replaces it (body FollowupIn: reason + the whole sequences array), DELETE clears it,
// POST .../followup/complete completes the whole follow-up and POST .../followup/mark_sequence_done completes the
// current (first open) sequence. All return the full lead. (Each has a lead/child/{uid}/... twin — not used yet.)
export const setLeadFollowup = (leadKey, data) => patchV2(`${API_LEAD}/${leadKey}/followup`, data)

export const deleteLeadFollowup = (leadKey) => deletedV2(`${API_LEAD}/${leadKey}/followup`)

export const completeLeadFollowup = (leadKey) => postV2(`${API_LEAD}/${leadKey}/followup/complete`, {})

export const markLeadFollowupSequenceDone = (leadKey) => postV2(`${API_LEAD}/${leadKey}/followup/mark_sequence_done`, {})
